import ActivityPageBanner from './ActivityPageBanner'
export default ActivityPageBanner

